import i18next from 'i18next';
import React from 'react';
import { Form } from 'react-final-form';

import { CompanyI } from '~src/interfaces/company.interface';
import { AnswerValue, SelectionValue } from '~src/interfaces/question.interface';
import { Segment, SegmentType } from '~src/interfaces/segment.interface';
import { CardContainer } from '~src/modules/questions/components/shared.sc';
import { getNameOfSegment } from '~src/services/getNameOfSegment';
import SvgIcon from '~src/shared/SvgIcon';
import UrlText from '~src/shared/UrlText';
import AvatarBox from '~src/shared/avatarBox/AvatarBox';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import {
  AvatarName,
  CardAvatar,
  CardControls,
  CardData,
  CardImage,
  CardInfo,
  CardInfoContainer,
  CardTopic,
  CardTopicAndQuestion,
  CommentSection,
  CornerButton,
  IconWrapper,
  ScaleContainer,
} from './card.sc';

interface Props {
  actionPanel: (change: (field: string, value: any) => void, saveLoading: boolean) => JSX.Element;
  commentField: JSX.Element | null;
  isCommentEnabled: boolean;
  // FIXME Card shouldn't know about company; it should only care about presenting its content
  company: CompanyI | null;
  topic?: string;
  cornerButton?: () => JSX.Element;
  description?: string | null;
  initialValues?: Partial<AnswerValue | SelectionValue>;
  onSubmit: (value: AnswerValue | SelectionValue) => void;
  saveLoading: boolean;
  showSpinner: boolean;
  subject: Segment | null;
  title: string;
  verticalScale?: boolean;
  t: i18next.TFunction;
}

class Card extends React.PureComponent<Props> {
  render() {
    const {
      actionPanel,
      commentField,
      company,
      cornerButton,
      description,
      initialValues,
      onSubmit,
      saveLoading,
      showSpinner,
      subject,
      title,
      verticalScale,
      topic,
      t,
      isCommentEnabled
    } = this.props;

    return (
      <Form enableReinitialize initialValues={initialValues} onSubmit={onSubmit}>
        {({ form, handleSubmit }) => (
          <CardContainer onSubmit={handleSubmit} $isCommentField={isCommentEnabled}>
            <CardInfoContainer $isCommentField={isCommentEnabled}>
              <CardControls>{cornerButton && <CornerButton>{cornerButton()}</CornerButton>}</CardControls>
              <CardInfo>
                <CardAvatar>
                  <CardImage>
                    {company && (
                      <AvatarBox
                        size={70}
                        type={subject !== null ? subject.type : SegmentType.Company}
                        name={subject !== null ? getNameOfSegment(t, subject, false) : company.name}
                        url={subject !== null ? subject.image_url : company.imageUrl}
                      />
                    )}
                  </CardImage>
                  <AvatarName>
                    {subject !== null ? getNameOfSegment(t, subject, false) : company && company.name}
                  </AvatarName>
                </CardAvatar>
              </CardInfo>

              <CardTopicAndQuestion $charCount={title.length}>
                {topic ? (
                  <CardTopic data-translation="x.questions.card.topic.label">
                    <SvgIcon name="iconTopicLabel" viewBoxWidth={45} /> {topic}
                  </CardTopic>
                ) : null}
                <CardData>
                  <UrlText text={title} />
                  <IconWrapper>{description && <HoverInfoIcon infoText={description} />}</IconWrapper>
                </CardData>
              </CardTopicAndQuestion>

              {isCommentEnabled && <CommentSection>{commentField}</CommentSection>}
            </CardInfoContainer>
            <ScaleContainer className={verticalScale ? 'vertical' : ''}>
              {showSpinner ? (
                // ie11
                <div>
                  <LoadingSpinner color="white" dotsMargin={10} size={20} />
                </div>
              ) : (
                <>{actionPanel(form.change as (k: any, v: any) => void, saveLoading || false)}</>
              )}
            </ScaleContainer>
          </CardContainer>
        )}
      </Form>
    );
  }
}

export default Card;
